import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../core/shared/shared.module';
import { dictionariesRootRouting } from './dictionariesRoot.rooting';

@NgModule({
    imports: [ CommonModule,
        dictionariesRootRouting,
        SharedModule ],
    exports: [],
    declarations: [],
    providers: [ ]
})
export class DictionariesRootModule { }